import React from "react";
import { observer } from "mobx-react";
import { generalConfigurationStore as store } from "../Stores/GeneralConfigurationStore";
import "./SummaryWrapper.css";
import { Link } from "react-router-dom";
import SummaryModuleEntity from "./SummaryModuleEntity";
import SummaryDetails from "./SummaryDetails";
import SummaryCustomerInformation from "./SummaryCustomerInformation";
import SummaryGeneralModuleEntity from "./SummaryGeneralModuleDetails";


@observer
class SummaryWrapper extends React.Component {


	render() {

		return (
			<div className="summary-wrapper">
				<div className="container">
					<div className="row">
						<SummaryModuleEntity/>
						{store.configs?.detailsStepHeadline &&
							<SummaryDetails />
						}
						<SummaryGeneralModuleEntity/>
						{store.configs?.cultivationTypeHeadline &&
							<SummaryCustomerInformation />
						}
						<div className="col-12 col-lg-11">
							<Link className="btn btn-primary" to="/sales-partner">
								{store.configs?.toplineRequest}
							</Link>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default SummaryWrapper;
